<template>
  <div>
    <form @submit.prevent="">
      <b-row>
        <b-col>
          <div :class="['form-group', isInvalid('caseType') ? 'has-danger' : '']">
            <label
              for="excmcase_caseType"
              class="form-control-label">{{$t('views.excmcase.form.caseType')}}
            </label>
            <fg-input :error="violations.caseType">
              <el-select
                id="excmcase_caseType"
                :class="['select-default', isInvalid('caseType') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.caseType')"
                filterable
                v-model="item.caseType">
                <el-option v-for="option in casetype"
                           class="select-default"
                           :value="option['@id']"
                           :label="option['title']"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="6" v-if="currentCaseParams.hasPriority">
          <div :class="['form-group', isInvalid('idPriority') ? 'has-danger' : '']">
            <label
              for="excmcase_idPriority"
              class="form-control-label">
              {{$t('views.excmcase.form.idPriority')}}
              <span v-for="(casePriority, key) in casePriorities" v-bind:key="key" class="badge mr-2" :style="'color: ' + casePriority.textColor + '; background-color: ' + casePriority.backgroundColor">
            {{casePriority.title}}
          </span>
            </label>
            <fg-input :error="violations.idPriority">
              <el-select
                id="excmcase_idPriority"
                :class="['select-default', isInvalid('idPriority') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.idPriority')"
                filterable
                v-model="item.idPriority">
                <el-option v-for="option in casePriorities"
                           class="select-default"
                           :value="option['@id']"
                           :label="option['title']"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="currentCaseParams.hasClient">
        <b-col>
          <div :class="['form-group', isInvalid('contractorUserData') ? 'has-danger' : '']">
            <label
              class="form-control-label">{{$t('views.excmcase.form.contractorUserData')}}</label>
            <fg-input :error="violations.contractorUserData">
              <base-select-input
                :disabled="isContractorUserDataDisabled"
                v-model="item.contractorUserData"
                :search-callback="userDataSearchCallback"
                :display-values="['fullName', 'firmname1']"
                :query-param="'userdata'"
                :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
              ></base-select-input>
            </fg-input>
          </div>
        </b-col>
        <b-col v-if="currentCaseParams.hasPartner" sm="12" md="6">
          <b-form-group>
            <label
              class="form-control-label">{{ $t('views.excmcasetype.form.enablePartner') }}
            </label>
            <fg-input :error="violations.partnerUserData">
              <base-select-input
                :display-values="['fullName', 'firmname1']"
                v-model="item.partnerUserData"
                :search-callback="partnerSearchCallback"
                :query-param="'userdata'"
                :disabled="isWholesaler"
                :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
              ></base-select-input>
            </fg-input>
          </b-form-group>
        </b-col>
        <b-col md="12" align-self="end" v-if="ableToUpdateUserData && !isContractorUserDataDisabled">
          <button
            type="button"
            class="btn btn-default mb-2"
            @click="showCreateContractorModal()"
          >
            {{ $t('menu.contractors.create') }}
          </button>
          <button
            type="button"
            class="btn btn-default mb-2"
            v-if="item.contractorUserData"
            @click="toggleUpdateUserDataModal()"
          >
            {{$t('views.agreements.form.editContractor')}}
          </button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="12" v-if="currentCaseParams.hasTicket">
          <div :class="['form-group', isInvalid('ticket') ? 'has-danger' : '']">
            <label
              for="excmcaseticket"
              class="form-control-label">{{$t('views.excmcase.form.ticket')}}
            </label>
            <fg-input :error="violations.ticket">
              <el-select
                id="excmcaseticket"
                :class="['select-default', isInvalid('ticket') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.ticket')"
                filterable
                v-model="item.idTicket">
                <el-option v-for="option in ticketOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option['title'].substring(0, 100)"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="currentCaseParams.hasAgreement && currentCaseParams.hasDevice">
        <b-col cols="12" class="mb-2">
          <label>{{$t('views.excmcase.form.onlyToDevice')}}: </label>
          <div>
            <b-form-radio-group buttons button-variant="outline-primary" id="requirePromotion" v-model="onlyToDevice">
              <b-form-radio button-variant="outline-primary" :value="true">{{$t('buttons.yes')}}</b-form-radio>
              <b-form-radio button-variant="outline-primary" :value="false">{{$t('buttons.no')}}</b-form-radio>
            </b-form-radio-group>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="6" v-if="currentCaseParams.hasAgreement && !onlyToDevice">
          <div :class="['form-group', isInvalid('agreement') ? 'has-danger' : '']">
            <label
              for="excmcase_agreement"
              class="form-control-label">{{$t('views.excmcase.form.agreement')}}</label>
            <b-row>
              <b-col class="pr-0">
                <fg-input :error="violations.agreement">
                  <el-select
                    id="excmcase_agreement"
                    :class="['select-default', isInvalid('agreement') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmcase.form.agreementSearch') + ' (' + EXCMAgreements.length + ')'"
                    filterable
                    remote
                    reserve-keyword
                    :disabled="!item.contractorUserData"
                    :loading="loading"
                    v-debounce="delay"
                    v-model="item.agreement">
                    <el-option v-for="option in EXCMAgreements"
                               class="select-default"
                               :value="option['@id']"
                               :label="option.agreementNumber"
                               :key="option['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
              </b-col>
              <b-col class="pl-0" cols="3" v-if="ableToCreateAgreement">
                <b-btn :disabled="!item.contractorUserData" class="m-0 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="addNewAgreement()" variant="success" v-b-tooltip.hover :title="$t('menu.agreements.create')">
                  <i class="fas fa-plus"></i>
                </b-btn>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="6" v-if="currentCaseParams.hasDevice">
          <label
            for="excmcase_idDevice"
            class="form-control-label">{{$t('views.excmcase.form.idDevice')}}</label>
          <b-row>
            <b-col class="pr-0">
              <div :class="['form-group', isInvalid('idDevice') ? 'has-danger' : '']">
                <fg-input :error="violations.idDevice">
                  <el-select
                    id="excmcase_idDevice"
                    :class="['select-default', isInvalid('idDevice') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmcase.form.idDeviceSearch') + ' (' + EXCMAgreementDevices.length + ')'"
                    filterable
                    remote
                    reserve-keyword
                    :disabled="!onlyToDevice && (!item.contractorUserData || !item.agreement)"
                    :loading="loading"
                    v-debounce="delay"
                    v-model="item.idDevice">
                    <el-option v-for="option in EXCMAgreementDevices"
                               class="select-default"
                               :value="option.device['@id']"
                               :label="option.device.name"
                               :key="option.device['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>
            </b-col>
            <b-col class="pl-0" cols="3" v-if="ableToCreateDevice">
              <b-btn :disabled="!onlyToDevice && (!item.contractorUserData || !item.agreement)" class="m-0 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="addNewDevice()" variant="success" v-b-tooltip.hover :title="$t('menu.devices.create')">
                <i class="fas fa-plus"></i>
              </b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="6" v-if="currentCaseParams.hasSLA && !onlyToDevice && !currentCaseParams.hasTicket">
          <div :class="['form-group', isInvalid('sla') ? 'has-danger' : '']">
            <label
              for="excmcase_sla"
              class="form-control-label">{{$t('views.excmcase.form.sla')}}</label>
            <fg-input :error="violations.sla">
              <el-select
                id="excmcase_sla"
                :class="['select-default', isInvalid('sla') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.sla') + ' (' + EXCMAgreementSlas.length + ')'"
                filterable
                :disabled="!item.contractorUserData || !item.agreement"
                :loading="loading"
                v-debounce="delay"
                v-model="item.sla">
                <el-option v-for="option in EXCMAgreementSlas"
                           class="select-default"
                           :value="option.sla['@id']"
                           :label="option.sla['title']"
                           :key="option.sla['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="6" v-else-if="currentCaseParams.hasSLA && !onlyToDevice && currentCaseParams.hasTicket">
          <div :class="['form-group', isInvalid('sla') ? 'has-danger' : '']">
            <label
              for="excmcase_sla"
              class="form-control-label">{{$t('views.excmcase.form.sla')}}</label>
            <fg-input :error="violations.sla">
              <el-select
                @input="calculateDeadlineDate($event, true)"
                id="excmcase_sla"
                :class="['select-default', isInvalid('sla') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.sla') + ' (' + EXCMAgreementSlas.length + ')'"
                filterable
                :loading="loading"
                v-debounce="delay"
                v-model="item.sla">
                <el-option v-for="option in EXCMSlas"
                           class="select-default"
                           :value="option['@id']"
                           :label="option['title']"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col v-if="currentCaseParams.hasGenre">
          <div :class="['form-group', isInvalid('caseGenre') ? 'has-danger' : '']">
            <label
              for="excmcase_caseGenre"
              class="form-control-label">{{$t('views.excmcase.form.caseGenre')}}</label>
            <fg-input :error="violations.caseGenre">
              <el-select
                id="excmcase_caseGenre"
                :class="['select-default', isInvalid('caseGenre') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.caseGenre')"
                filterable
                v-model="item.caseGenre">
                <el-option v-for="option in caseGenres"
                           class="select-default"
                           :value="option['@id']"
                           :label="option['title']"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="false">
          <div :class="['form-group', isInvalid('caseTags') ? 'has-danger' : '']">
            <label
              for="excmcase_caseTags"
              class="form-control-label">{{$t('views.excmcase.form.caseTags')}}
            </label>
            <el-tag
              :key="index"
              v-for="(tag,index) in item.caseTags"
              size="small"
              type="success"
              :closable="true"
              :close-transition="false"
              @close="handleClose(index)"
            >
              {{tag}}
            </el-tag>

            <input type="text" :placeholder="$t('views.excmcase.form.addNewCaseTags')"
                   class="form-control input-new-tag"
                   v-model="tags.inputValue"
                   ref="saveTagInput"
                   size="mini"
                   @keyup.enter="handleInputConfirm"
                   @blur="handleInputConfirm"/>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!isWholesaler && !isSalesRepresentative">
        <b-col>
          <div class="form-group">
            <label
              for="excmcase_deadlineDate"
              class="form-control-label">{{$t('views.excmcase.form.deadlineDate')}}:</label>
            <fg-input :error="violations.deadlineDate">
              <el-date-picker
                v-model="item.deadlineDate"
                type="datetime"
                default-time="12:00:00"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                :picker-options="pickerOptions">
              </el-date-picker>
            </fg-input>
            <div
              v-if="isInvalid('deadlineDate')"
              class="invalid-feedback">{{ violations.deadlineDate }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div :class="['form-group', isInvalid('description') ? 'has-danger' : '']">
            <label
              for="excmcase_description"
              class="form-control-label">{{$t('views.excmcase.form.description')}}</label>
            <textarea
              id="excmcase_description"
              v-model="item.description"
              :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('description', $event.target.value)">
        </textarea>
            <div
              v-if="isInvalid('description')"
              class="invalid-feedback">{{ violations.description }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="item.customFields && item.customFields.length > 0">
        <b-col>
          <b-row v-for="(customField, index) in item.customFields" v-bind:key="'customField-' + index">
            <b-col>
              <CasesCustomFields :item="customField"></CasesCustomFields>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <CaseProblems :data="item"></CaseProblems>
        </b-col>
      </b-row>
    </form>
    <button @click="handleSubmit(item, true)" class="btn btn-success">{{$t('buttons.submit')}}</button>
    <create-contractor-modal></create-contractor-modal>
    <update-contractor-modal :id-user-data="item.contractorUserData"></update-contractor-modal>
    <DeviceFormModal v-if="ableToCreateDevice"></DeviceFormModal>
    <CreateAgreementModal v-if="ableToCreateAgreement"></CreateAgreementModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import { Switch } from 'src/components/UIComponents'
import debounce from 'v-debounce' // search params with delay when typing
import { Tag } from 'element-ui'
import CasesCustomFields from './components/CasesCustomFields'
import CaseProblems from '@/components/Dashboard/Views/excmcase/components/CaseProblems'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import CreateContractorModal from '@/components/Dashboard/Views/firm/modals/CreateModal'
import UpdateContractorModal from '@/components/Dashboard/Views/firm/modals/UpdateModal'
import DeviceFormModal from '@/components/Dashboard/Views/excmdevice/components/DeviceFormModal/DeviceFormModal'
import CreateAgreementModal from '@/components/Dashboard/Views/excmagreement/components/CreateAgreementModal'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import { ENTRYPOINT } from '@/config/entrypoint'

export default {
  components: {
    CreateAgreementModal,
    DeviceFormModal,
    CaseProblems,
    [Switch.name]: Switch,
    [Tag.name]: Tag,
    CasesCustomFields,
    CreateContractorModal,
    UpdateContractorModal,
    BaseSelectInput
  },

  props: {
    isContractorUserDataDisabled: {
      required: false,
      default () {
        return false
      }
    },
    userDataFirms: {
      required: false,
      default () {
        return false
      }
    },
    handleSubmit: {
      type: Function,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  directives: {
    debounce
  },

  watch: {
    onlyToDevice (val) {
      this.item.agreement = null
      this.item.idDevice = null
      this.item.sla = null
      if (val) {
        this.getContractorDevices()
      } else {
        this.EXCMAgreementDevices = []
      }
    },
    createdContractor: {
      handler (val) {
        if (val) {
          this.item.contractorUserData = val['@id']
        }
      }
    },
    createdDevice: {
      handler (val) {
        if (val) {
          this.item.idDevice = val['@id']
          if (this.onlyToDevice) {
            this.getContractorDevices()
          } else {
            this.getAgreementDevices(false)
          }
        }
      }
    },
    createdAgreement: {
      handler (val) {
        if (val) {
          // this.getAgreements(true)
          this.item.contractorUserData = val.company['@id']
          this.item.agreement = val['@id']
        }
      }
    },
    userDataFirms (val) {
      if (val) {
        this.userDataOptions = this.filterUserDataOptionsByIds(val)
      } else {
        this.userDataOptions = this.userDatas
      }
    },
    'item.contractorUserData' (val) {
      this.clearSearchParams()
      this.ticketOptions = []
      if (val) {
        this.params.application = val
      }
      this.getTickets()
      if (this.onlyToDevice) {
        this.getContractorDevices()
      }
    },
    item (val) {
      if (this.initialValues) {
        this.caseTypeSelectedHandler(val.caseType)
      }
    },
    'item.caseType': {
      immediate: true,
      handler (val) {
        this.caseTypeSelectedHandler(val)
      }
    },
    'item.sla': {
      immediate: true,
      handler (val) {
        this.EXCMAgreementSlas.forEach((agreementSla) => {
          if (agreementSla.sla['@id'] === val) {
            this.slaDuration = agreementSla.sla.repairTime
            this.slaDurationUnit = agreementSla.sla.repairTimeUnit
          }
        })
        this.EXCMSlas.forEach((sla) => {
          if (sla['@id'] === val) {
            this.slaDuration = sla.repairTime
            this.slaDurationUnit = sla.repairTimeUnit
          }
        })
        this.calculateDeadlineDate()
      }
    }
  },

  data () {
    return {
      moment,
      params: {
        'pagination': false
      },
      pickerOptions: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: '7 dni',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setTime(date.getTime() + 7 * 86400000)))
            }
          },
          {
            text: '10 Dni',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setTime(date.getTime() + 10 * 86400000)))
            }
          },
          {
            text: '2 tygodnie',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setTime(date.getTime() + 14 * 86400000)))
            }
          },
          {
            text: '1 miesiąc',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setMonth(date.getMonth() + 1)))
            }
          }
        ]
      },
      searchUserDataInput: '',
      partnerOptions: [],
      ticketOptions: [],
      onlyToDevice: false,
      routeName: '',
      delay: 500,
      companyUserDatas: [],
      EXCMAgreementDevices: [],
      caseGenres: [],
      customFields: [],
      casePriorities: [],
      EXCMAgreementSlas: [],
      EXCMAgreements: [],
      EXCMSlas: [],
      deadlineDate: null,
      caseTypeDuration: '',
      caseTypeDurationUnit: '',
      slaDuration: '',
      slaDurationUnit: '',
      loading: false,
      tags: {
        dynamicTags: [],
        inputVisible: false,
        inputValue: ''
      }
    }
  },

  computed: {
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    isSalesRepresentative () {
      return getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE')
    },
    userId () {
      let userEmployer = null
      if (!isNaN(getUserRoles().user_employer)) {
        userEmployer = getUserRoles().user_employer
      }
      return this.path + 'user_datas/' + (userEmployer || getUserRoles().id_userdata)
    },
    ableToUpdateUserData () {
      return checkPermission('firms', 'FirmCreate')
    },
    ableToCreateDevice: function () {
      return checkPermission('devices', 'EXCMDeviceCreate')
    },
    ableToCreateAgreement: function () {
      return checkPermission('agreements', 'EXCMAgreementCreate')
    },
    userDataOptions () {
      if (this.userDataFirms && this.userDataFirms.length > 0) {
        return this.filterUserDataOptionsByIds(this.userDataFirms)
      } else {
        return this.userDatas
      }
    },
    ...mapGetters({
      casetype: 'excmcasetype/list/items',
      userDatas: 'excmcase/list/getUserDataOptions',
      filterUserDataOptionsByIds: 'excmcase/list/filterUserDataOptionsByIds',
      createdContractor: 'userdata/create/created',
      createdDevice: 'excmdevice/create/created',
      createdAgreement: 'excmagreement/create/created'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },
    currentCaseParams () {
      let caseParams = {
        hasNotes: false,
        hasCategorization: false,
        hasTimeline: false,
        hasTicket: false,
        hasClient: false,
        hasDevice: false,
        hasAgreement: false,
        hasSLA: false,
        hasPriority: false,
        hasGenre: false
      }
      let caseType = this.item.caseType
      this.casetype.forEach((casetype) => {
        if (casetype['@id'] === caseType) {
          Object.assign(caseParams, casetype.caseParams)
        }
      })
      return caseParams
    }
  },

  created () {
    this.routeName = this.$route.name
    this.getCaseType()
    this.getCaseGenres()
    this.getCasePriorities()
    if (this.item['@id'] && this.item.contractorUserData) {
      this.getAgreements(true)
    } else {
      // creating watcher
      this.createWatchers()
    }
    this.getTickets()
    this.getTicketSlas()
    if (this.isWholesaler) {
      this.item.partnerUserData = this.userId
    }
  },

  methods: {
    caseTypeSelectedHandler (val) {
      this.casetype.forEach((casetype) => {
        if (casetype['@id'] === val) {
          this.caseTypeDuration = casetype.duration
          this.caseTypeDurationUnit = casetype.durationUnit
        }
      })
      this.calculateDeadlineDate()
    },

    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async partnerSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1, state: 1, idClientType: this.$store.getters['configuration/clientTypesForPartnerUserData'] }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    ...mapMutations({
      showCreateContractorModal: 'userdata/createModal/toggleModal',
      toggleUpdateUserDataModal: 'userdata/updateModal/toggleModal'
    }),
    ...mapActions({
      getCaseType: 'excmcasetype/list/default',
      getUserDatas: 'excmcase/list/fetchUserDataOptions'
    }),
    calculateDeadlineDate (val = null, manualChange = false) {
      if (this.item['@id'] && !manualChange) { // Podpowiadanie terminu wykonania będzie tylko dla nowych zleceń
        return
      }
      if (manualChange) {
        this.EXCMSlas.forEach((sla) => {
          if (sla['@id'] === val) {
            this.slaDuration = sla.repairTime
            this.slaDurationUnit = sla.repairTimeUnit
          }
        })
      }
      let duration = 0
      let durationUnit = 0
      if (this.slaDuration && this.slaDurationUnit) {
        duration = this.slaDuration
        durationUnit = this.slaDurationUnit
      } else if (this.caseTypeDuration && this.caseTypeDurationUnit) {
        duration = this.caseTypeDuration
        durationUnit = this.caseTypeDurationUnit
      }
      if (duration && durationUnit) {
        let now = this.moment(this.item.createdAt)
        if (durationUnit === 1) {
          this.item.deadlineDate = now.add(duration, 'minutes').format('YYYY-MM-DD HH:mm')
        } else if (durationUnit === 2) {
          this.item.deadlineDate = now.add(duration, 'hours').format('YYYY-MM-DD HH:mm')
        } else if (durationUnit === 3) {
          this.item.deadlineDate = now.add(duration, 'days').format('YYYY-MM-DD HH:mm')
        } else if (durationUnit === 4) { // dni robocze
          let days = 0
          while (days < duration) {
            now = now.add(1, 'days')
            if (now.isoWeekday() < 6) {
              days++
            }
          }
          this.item.deadlineDate = now.format('YYYY-MM-DD HH:mm')
        } else if (durationUnit === 5) { // godziny robocze
          let hours = 0
          while (hours < duration) {
            now = now.add(1, 'hours')
            if (now.isoWeekday() < 6 && now.hour() >= 8 && now.hour() < 16) {
              hours++
            }
          }
          this.item.deadlineDate = now.format('YYYY-MM-DD HH:mm')
        }
      }
    },
    createWatchers () {
      // creating watcher
      this.createCaseTypeWatcher()
      this.createContractorUserDataWatcher()
      this.createAgreementWatcher()
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    createContractorUserDataWatcher () {
      this.unwatchContractorUserData = this.$watch(
        function () {
          return this.item.contractorUserData
        },
        function (newValue) {
          this.item.agreement = null
          this.getAgreements()
        }
      )
    },
    createAgreementWatcher () {
      this.unwatchAgreement = this.$watch(
        function () {
          return this.item.agreement
        },
        function (newValue) {
          this.item.idDevice = null
          this.item.sla = null
          this.getAgreementDevices()
          this.getAgreementSlas()
        }
      )
    },
    async getAgreementSlas (createWatchers) {
      if (this.item.agreement) {
        let idAgreement = this.getIdLink(this.item.agreement)
        let params = {
          'agreement.id': idAgreement,
          pagination: false
        }
        const response = await new ApiService('e_x_c_m_agreement_slas', params).getResults()
        this.EXCMAgreementSlas = response.items
        if (createWatchers) {
          this.createWatchers()
        }
      }
    },
    async getTicketSlas () {
      const response = await new ApiService('e_x_c_m_slas', { pagination: false }).getResults()
      this.EXCMSlas = response.items
    },
    async getAgreementDevices (createWatchers) {
      if (this.item.agreement) {
        let idAgreement = this.getIdLink(this.item.agreement)
        // this.item.idDevice = null
        this.EXCMAgreementDevices = []
        const response = await new ApiService(`e_x_c_m_agreements/${idAgreement}/agreement_devices`).getResults()
        this.EXCMAgreementDevices = response.items
        if (createWatchers) {
          this.createWatchers()
        }
      }
    },
    async getContractorDevices () {
      this.EXCMAgreementDevices = []
      let params = {
        'state': 1,
        'idContractorUserData': this.getIdLink(this.item.contractorUserData),
        'pagination': false
      }
      const response = await new ApiService(`e_x_c_m_devices`, params).getResults()
      this.EXCMAgreementDevices = response.items.map(item => {
        return { device: item }
      })
    },
    async getAgreements (getDevice = null) {
      if (this.item.contractorUserData) {
        let params = {
          'state': 1,
          'company': this.getIdLink(this.item.contractorUserData),
          'pagination': false
        }
        this.EXCMAgreements = []
        this.EXCMAgreementDevices = []
        this.EXCMAgreementSlas = []
        const response = await new ApiService('e_x_c_m_agreements', params).getResults()
        this.EXCMAgreements = response.items
        if (getDevice) {
          await this.getAgreementDevices(true)
          await this.getAgreementSlas(true)
        }
      }
    },
    createCaseTypeWatcher () {
      this.unwatchCaseType = this.$watch(
        function () {
          return this.item.caseType
        },
        async function (newValue) {
          this.item.customFields = []
          const response = await new ApiService('e_x_c_m_case_types/' + this.getIdLink(newValue)).getResults()
          if (response.customFields.length > 0) {
            response.customFields = response.customFields.filter(entry => entry.state === 1)
            for (let f in response.customFields) {
              let item = {
                name: '',
                value: '',
                options: [],
                required: false,
                onlyNumbersAllowed: false,
                allowedDaysAhead: response.customFields[f].allowedDaysAhead,
                allowedDaysBack: response.customFields[f].allowedDaysBack,
                minValue: response.customFields[f].minValue,
                maxValue: response.customFields[f].maxValue,
                type: '',
                disabledRoles: response.customFields[f].disabledRoles
              }
              item.name = response.customFields[f].fieldName
              item.type = response.customFields[f].fieldType
              if (response.customFields[f].fieldRequired === 0) {
                item.required = false
              } else {
                item.required = true
              }
              if (response.customFields[f].fieldReadonly === 0) {
                item.readonly = false
              } else {
                item.readonly = true
              }
              if (response.customFields[f].fieldType === 'input' && response.customFields[f].onlyNumbersAllowed === 1) {
                item.onlyNumbersAllowed = true
              } else {
                item.onlyNumbersAllowed = false
              }
              if (item.type === 'select') {
                if (response.customFields[f].fieldValues.length > 0) {
                  for (let v in response.customFields[f].fieldValues) {
                    let option = {
                      value: response.customFields[f].fieldValues[v].value,
                      defaultValue: response.customFields[f].fieldValues[v].defaultValue
                    }
                    item.options.push(option)
                  }
                }
                if (item.options.length > 0) {
                  for (let o in item.options) {
                    if (item.options[o].defaultValue === 1) {
                      item.value = item.options[o]['value']
                    }
                  }
                }
              }
              if (item.type === 'multiSelect') {
                if (response.customFields[f].fieldValues.length > 0) {
                  item.value = []
                  for (let v in response.customFields[f].fieldValues) {
                    let option = {
                      value: response.customFields[f].fieldValues[v].value,
                      defaultValue: response.customFields[f].fieldValues[v].defaultValue
                    }
                    item.options.push(option)
                  }
                }
                if (item.options.length > 0) {
                  for (let o in item.options) {
                    if (item.options[o].defaultValue === 1) {
                      item.value.push(item.options[o]['value'])
                    }
                  }
                }
              }
              if (item.type === 'inputFormatted' && response.customFields[f].fieldDefaultValue) {
                item.value = response.customFields[f].fieldDefaultValue
              }
              if (item.type === 'itemsCollection') {
                item.value = []
              }
              if (item.type === 'idUserData') {
                item.displayValue = ''
                item.idUserDataClientTypes = response.customFields[f].idUserDataClientTypes ? response.customFields[f].idUserDataClientTypes : []
              }
              item.label = response.customFields[f].fieldLabel
              this.item.customFields.push(item)
            }
          }
        }
      )
    },
    async getCaseGenres () {
      let params = {
        'pagination': false
      }
      const response = await new ApiService('e_x_c_m_case_genres', params).getResults()
      this.caseGenres = response.items
    },
    async getCasePriorities () {
      let params = {
        'pagination': false
      }
      const response = await new ApiService('e_x_c_m_case_priorities', params).getResults()
      this.casePriorities = response.items
    },
    getIdLink (link) {
      return getId(link)
    },
    // tags functions
    handleClose (index) {
      this.item.caseTags.splice(index, 1)
    },
    showInput () {
      this.tags.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      if (!this.item.caseTags) {
        this.item.caseTags = []
      }
      let inputValue = this.tags.inputValue
      if (inputValue) {
        this.item.caseTags.push(inputValue)
      }
      this.tags.inputVisible = false
      this.tags.inputValue = ''
    },
    async getTickets () {
      const response = await new ApiService('tickets', this.params).getResults()
      this.ticketOptions = response.items
    },
    clearSearchParams () {
      this.params = {
        'pagination': false
      }
    },
    editContractor (id) {
      this.$router.push({ name: 'FirmUpdate', params: { id: id } })
    },
    addNewDevice () {
      this.$store.state.modals.excmdevice.form.show = 1
    },
    addNewAgreement () {
      this.$store.state.modals.excmagreement.create.show = 1
    }
  }
}
</script>
